// Carga todas las definiciones de piezas en el registro (una familia por archivo).
import './boards.js';
import './pico.js';
import './breadboard.js';
import './basic.js';
import './lcd.js';
import './servo.js';
import './displays.js';
import './sensors.js';
import './inputs.js';
import './actuators.js';
import './tools.js';
import './comms.js';
import './tft.js';
import './extras.js';
import './boards-mini.js';
import './usbserial.js';

export * from './registry.js';
